import styles from "./mask.module.scss";

type MaskProps = {
  showMask: boolean;
  handleCloser: () => void;
  zIndex ?: number
};
export const Mask = ({ handleCloser, showMask ,zIndex}: MaskProps) => {
  return (
    <div
      className={`${styles.backdrop} animate__animated ${
        showMask ? "animate__fadeIn" : "animate__fadeOut"
      }`}
      style={{zIndex : zIndex}}
      onClick={() => {
        handleCloser();
      }}
    ></div>
  );
};
